import React from "react";
//#region types
import { WidgetAreaProps } from "models/propTypes/homePropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { ComponentHiddenStatus } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TopRightWidgetArea: React.FC<WidgetAreaProps> = (props) => {
  return (
    <Grid item className={cssExports.topRightWidgetContainer}>
      <Grid
        container
        spacing={3}
        direction={{ lg: "column-reverse", sm: "row-reverse", xs: "column-reverse" }}
        wrap="nowrap"
      >
        {props.children.map((childElem, index) => (
          <ComponentHiddenStatus
            key={index}
            render={(isHidden, setIsHidden) => (
              <Grid item xs={12} sm={6} lg={12} className={isHidden ? cssExports.hidden : cssExports.widgetContainer}>
                {React.cloneElement(childElem, {
                  onVisibilityChange: setIsHidden,
                })}
              </Grid>
            )}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default TopRightWidgetArea;
